import { FloatingFocusManager, FloatingList, FloatingPortal } from '@floating-ui/react';
import classnames from 'classnames';
import React, { useContext } from 'react';
import { MenuContext } from "../../context/MenuContext.js";
import { SettingsContext } from "../../context/SettingsContext.js";
import { useMobileCheck } from "../../hooks/useMobileCheck.js";
import styles from "./ContextMenuColumnList.module.js";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function ContextMenuColumnList({
  children,
  level,
  setInitialFocus
}) {
  const {
    isOpen,
    context,
    refs,
    floatingStyles,
    getFloatingProps,
    listRef,
    labelsRef
  } = useContext(MenuContext);
  const isMobile = useMobileCheck();
  const {
    className,
    style,
    externalSearch
  } = useContext(SettingsContext);
  if (!context || !listRef || !labelsRef) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(FloatingList, {
    elementsRef: listRef,
    labelsRef: labelsRef,
    children: isOpen && /*#__PURE__*/_jsx(FloatingPortal, {
      children: /*#__PURE__*/_jsx(FloatingFocusManager, {
        context: context,
        modal: false,
        initialFocus: setInitialFocus ? 0 : -1,
        returnFocus: setInitialFocus,
        children: /*#__PURE__*/_jsx("div", {
          ref: refs?.setFloating,
          className: classnames(className, styles.column),
          "data-level": level,
          "data-force-desktop-ui": externalSearch ? 'true' : 'false',
          style: isMobile ? {
            ...style,
            position: 'fixed',
            inset: '0'
          } : {
            ...style,
            ...floatingStyles
          },
          ...getFloatingProps(),
          children: children
        })
      })
    })
  });
}